import styled from 'styled-components/macro';

import { Spinner } from './Spinner';

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-5);
`;

const StyledText = styled.p`
  font-weight: var(--font-weight-medium);
`;

/** A spinner that consists of the spinner circles and a text message below. */
export const BlockSpinner = () => (
  <StyledContainer role="status">
    <Spinner size="lg" />
    <StyledText>Loading, please wait&hellip;</StyledText>
  </StyledContainer>
);
